.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.loadingRoller {
  display: inline-block;
  position: relative;
  margin: 2rem;
  width: 80px;
  height: 80px;
  transform: scale(0.8);
}
.loadingRoller div {
  animation: loadingRoller 1.6s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}
.loadingRoller div:after {
  content: ' ';
  display: block;
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #1365d1;
  margin: -4px 0 0 -4px;
}
.loadingRoller div:nth-child(1) {
  animation-delay: -0.036s;
}
.loadingRoller div:nth-child(1):after {
  top: 63px;
  left: 63px;
}
.loadingRoller div:nth-child(2) {
  animation-delay: -0.072s;
}
.loadingRoller div:nth-child(2):after {
  top: 68px;
  left: 56px;
}
.loadingRoller div:nth-child(3) {
  animation-delay: -0.108s;
}
.loadingRoller div:nth-child(3):after {
  top: 71px;
  left: 48px;
}
.loadingRoller div:nth-child(4) {
  animation-delay: -0.144s;
}
.loadingRoller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}
.loadingRoller div:nth-child(5) {
  animation-delay: -0.18s;
}
.loadingRoller div:nth-child(5):after {
  top: 71px;
  left: 32px;
}
.loadingRoller div:nth-child(6) {
  animation-delay: -0.216s;
}
.loadingRoller div:nth-child(6):after {
  top: 68px;
  left: 24px;
}
.loadingRoller div:nth-child(7) {
  animation-delay: -0.252s;
}
.loadingRoller div:nth-child(7):after {
  top: 63px;
  left: 17px;
}
.loadingRoller div:nth-child(8) {
  animation-delay: -0.288s;
}
.loadingRoller div:nth-child(8):after {
  top: 56px;
  left: 12px;
}
@keyframes loadingRoller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
